import { Filter, FilterType, FilterValue } from '../../domain/Filter';

export interface FilterToRemove {
    type: FilterType;
    value?: FilterValue;
}

type FilterReducer = (filters: Filter[], filterToAdd: Filter) => Filter[];

export const addFilterToArray = (filters: Filter[], filterToAdd: Filter): Filter[] => {
    if (filterToAdd.single) {
        return [removeSameType, addIfNotExist].reduce((result: Filter[], current: FilterReducer) => {
            return current(result, filterToAdd);
        }, filters);
    }
    return addIfNotExist(filters, filterToAdd);
};

export const removeFilterFromArray = (filters: Filter[], filterToRemove: FilterToRemove): Filter[] =>
    filters.filter(
        (filter: Filter) => filter.type !== filterToRemove.type || (filterToRemove.value && filter.value !== filterToRemove.value)
    );

const addIfNotExist = (filters: Filter[], filterToAdd: Filter): Filter[] => {
    if (!filters.some(filter => filter.type === filterToAdd.type && filter.value === filterToAdd.value)) {
        return [...filters, filterToAdd];
    }
    return filters;
};

const removeSameType = (filters: Filter[], filterToRemove: Filter): Filter[] =>
    filters.filter((filter: Filter) => filter.type !== filterToRemove.type);



// WEBPACK FOOTER //
// ./src/application/core/arrayOperations.ts